module.exports = __webpack_public_path__ + "media/images/icons/youtube-e648574e2e81f90f470ba6d5b4083238.svg";